module.exports = __webpack_public_path__ + "img/logo.37fc3f21.svg";